export var DeviceType;
(function (DeviceType) {
    DeviceType["DESKTOP"] = "desktop";
    DeviceType["MOBILE"] = "mobile";
})(DeviceType || (DeviceType = {}));
//# sourceMappingURL=WixSDKPort.js.map